<template>
  <b-container fluid style="height:580px; overflow-y:auto;">
    <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
    ></b-spinner>

    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Forms Page</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              class="my-2 my-sm-0 mr-2"
              variant="outline-primary"
              size="sm"
              @click="showNewCreateFormModal=!showNewCreateFormModal"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
            <b-button
              variant="outline-info"
              size="sm"
              style="margin-right:30px;"
              @click="reloadTable"
            >
              <font-awesome-icon icon="sync" />
            </b-button>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-row>
      <b-col cols="12">
        <b-table
          sticky-header="475px"
          ref="table"
          id="my-table"
          :busy.sync="isLoading"
          :items="myProvider"
          :fields="fields"
          :filter="filter"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
          <template v-slot:cell(type)="data">
            <p>{{formTypes[(data.item.type - 1)]}}</p>
          </template>

          <template v-slot:cell(created_at)="data">
            <p>{{data.item.created_at}}</p>
          </template>

          <template v-slot:cell(title)="data">
            <a href="#" @click="getForm(data.item.id, '/form/configuration')">{{data.item.title}}</a>
          </template>

          <template v-slot:cell(is_active)="data">
            <b-badge :variant="data.is_active == 1 ? 'success':'warning '">Draft</b-badge>
          </template>

          <template v-slot:cell(actions)="data">
            <font-awesome-icon
              v-b-tooltip.hover
              title="Edit Form"
              class="mr-2 text-primary"
              icon="edit"
              @click="getForm(data.item.id, '/form/configuration')"
            />
            <font-awesome-icon
              v-b-tooltip.hover
              title="Preview Form"
              class="ml-2 text-success"
              icon="eye"
              @click="viewUserForm(data.item.id, '/user-form')"
              to="/user-form"
            />
            <font-awesome-icon
              v-b-tooltip.hover
              title="Duplicate Form"
              class="ml-2 text-warning"
              icon="copy"
              @click="duplicateFormModal(data.item.title,data.item.description,data.item.id,data.item.clientId)"
            />
            <font-awesome-icon
              :disabled="data.is_active == 0"
              v-b-tooltip.hover
              title="Delete Form"
              :class="data.item.is_active == 0 ?  'ml-2 text-danger ' : 'ml-2 text-light'"
              icon="trash"
            />
          </template>
          <template v-slot:cell(selection)="data">
            <b-form-checkbox
              :id="'checkbox'+data.index"
              v-model="data.index"
              name="checkbox-1"
              value="selected"
              unchecked-value="not_selected"
            ></b-form-checkbox>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="1">
        <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
      </b-col>
      <b-col>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      id="bv-modal-newform"
      size="lg"
      v-model="showNewCreateFormModal"
      scrollable
      no-close-on-backdrop
      hide-footer
      :hide-header="isGlobalLoader"
    >
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->

        <h5>Create New Form</h5>
      </template>
      <AppLoader v-if="isGlobalLoader" small />
      <b-form v-if="!submiting && !responseSuccess">
        <b-form-group label="Client">
          <v-select
            :searchable="true"
            :clearable="true"
            label="text"
            code="value"
            v-model="$v.newForm.clientId.$model"
            :state="$v.newForm.clientId.$dirty ? !$v.newForm.clientId.$error : null"
            aria-describedby
            :options="clients"
          ></v-select>
          <b-form-invalid-feedback
            id="input-2-live-feedback"
          >This is a required field and must be select One option</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Form Title">
          <b-form-input
            placeholder="Enter form title"
            v-model="$v.newForm.formTitle.$model"
            :state="$v.newForm.formTitle.$dirty ? !$v.newForm.formTitle.$error : null"
            aria-describedby
          ></b-form-input>
          <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Form Description">
          <b-form-textarea
            placeholder="Enter the form description"
            rows="3"
            v-model="$v.newForm.formDescription.$model"
            :state="$v.newForm.formDescription.$dirty ? !$v.newForm.formDescription.$error : null"
            aria-describedby
          ></b-form-textarea>
          <b-form-invalid-feedback>This is a required field and must be at least 10 characters.</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Form Type">
          <b-form-radio-group
            id="radio-group-1"
            v-model="$v.newForm.selectFormType.$model"
            :state="$v.newForm.selectFormType.$dirty ? !$v.newForm.selectFormType.$error : null"
            :options="optionsFormType"
            name="radio-options"
          ></b-form-radio-group>
          <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
        </b-form-group>
      </b-form>

      <div v-else-if="submiting && !responseSuccess">
        <p>Your Form is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your form has been created successfully. Would you like to create another form?
          <br />
        </p>
        <p class="text-center mt-3">
          <b-button
            @click="responseSuccess = !responseSuccess"
            variant="primary"
            size="lg"
          >Create a new form</b-button>
        </p>
        <p class="my-2 text-center">Would you like to edit that form.</p>
        <p class="text-center mb-5 mt-3">
          <b-button
            title="Edit Form"
            class="mr-2 text-primary"
            @click="getForm(newFormId, '/form/configuration')"
          >
            <font-awesome-icon icon="edit" />
          </b-button>
        </p>
      </div>

      <div class="float-right">
        <b-button
          class="mr-3"
          id="close-btn"
          variant="secondary"
          v-if="!submiting"
          @click="resetForm"
        >Close</b-button>
        <b-button
          v-if="!responseSuccess"
          variant="outline-success"
          :disabled="$v.newForm.$invalid"
          @click="createForm"
        >
          <b-spinner v-if="submiting" type="grow" label="Loading..."></b-spinner>Create
        </b-button>
      </div>

      <div class="clearfix"></div>
    </b-modal>

    <b-modal
      id="bv-modal-duplicateform"
      size="lg"
      no-close-on-backdrop
      v-model="showDuplicateFormModal"
      scrollable
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h5>Duplicate Form</h5>
      </template>
      <div>
        <b-form v-if="!submiting && !responseSuccess">
          <b-form-group label="Client">
            <v-select
              :searchable="true"
              :clearable="true"
              label="text"
              code="value"
              v-model="$v.duplicateForm.duplicateClientId.$model"
              :state="$v.duplicateForm.duplicateClientId.$dirty ? !$v.duplicateForm.duplicateClientId.$error : null"
              aria-describedby
              :options="clients"
            ></v-select>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Form Title">
            <b-form-input
              placeholder="Enter form title"
              v-model="$v.duplicateForm.duplicateTitle.$model"
              :state="$v.duplicateForm.duplicateTitle.$dirty ? !$v.duplicateForm.duplicateTitle.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Form Description">
            <b-form-textarea
              placeholder="Enter the form description"
              rows="3"
              v-model="$v.duplicateForm.duplicateDescription.$model"
              :state="$v.duplicateForm.duplicateDescription.$dirty ? !$v.duplicateForm.duplicateDescription.$error : null"
            ></b-form-textarea>
            <b-form-invalid-feedback>This is a required field and must be at least 10 characters.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Form Type">
            <b-form-radio-group
              id="radio-group-1"
              v-model="$v.duplicateForm.duplicateselectFormType.$model"
              :state="$v.duplicateForm.duplicateselectFormType.$dirty ? !$v.duplicateForm.duplicateselectFormType.$error : null"
              :options="optionsFormType"
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
        </b-form>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Form is being submited......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>

        <div v-else>
          <p class="my-2 text-center">
            Your form has been created successfully.
            <br />
          </p>
        </div>
        <div class="float-right">
          <b-button
            class="mr-3"
            id="close-btn"
            variant="danger"
            v-if="!submiting"
            @click="resetDuplicateForm"
          >Close</b-button>
          <b-button
            v-if="!responseSuccess"
            variant="outline-success"
            :disabled="$v.duplicateForm.$invalid"
            @click="duplicateForms"
          >
            <b-spinner v-if="submiting" type="grow" label="Loading..."></b-spinner>Create
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import { Helper } from "../../helpers";
import AppHeader from "../../components/header/header";
import { HTTP } from "../../utils/HTTP";
import AppLoader from "../../components/Loader/Loader";
import uid from "uid";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "ClientProfileForms",
  mixins: [validationMixin],
  data() {
    return {
      perPage: 25,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      fields: [
        { key: "id", label: "id", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "title", sortable: true },
        { key: "name", label: "Creator Name", sortable: true },
        { key: "created_at", sortable: true },
        { key: "is_active", sortable: false },
        { key: "actions", sortable: false },
        { key: "selection", label: "", sortable: false }
      ],
      filter: null,
      formTypes: ["Questionaire", "Survey", "Training", "Exam", "Reference"],
      isLoading: false,
      submiting: false,
      isHidden: false,
      responseSuccess: false,
      placeholderVersion: "e.g. 1.0.2",
      newForm: {
        formTitle: null,
        formDescription: null,
        clientId: null,
        selectFormType: 1
      },
      translationLanguage: "english",
      showNewCreateFormModal: false,
      showDuplicateFormModal: false,
      showCollapse: true,
      clients: [],
      formTable: [],
      duplicateForm: {
        duplicateTitle: null,
        duplicateDescription: null,
        duplicateselectFormType: null,
        duplicateClientId: null
      },
      optionsFormType: [
        { value: 1, text: "Questionaire" },
        { value: 2, text: "Survey" },
        { value: 3, text: "Training" },
        { value: 4, text: "Exam" }
      ],
      duplicateId: null,
      duplicateClientId: null,
      newFormId: null
    };
  },
  validations: {
    newForm: {
      formTitle: {
        required,
        minLength: minLength(5)
      },
      formDescription: {
        required,
        minLength: minLength(10)
      },
      selectFormType: {
        required
      },
      clientId: {
        required
      }
    },
    duplicateForm: {
      duplicateTitle: {
        required,
        minLength: minLength(5)
      },
      duplicateDescription: {
        required,
        minLength: minLength(10)
      },
      duplicateselectFormType: {
        required
      },
      duplicateClientId: {
        required
      }
    }
  },
  components: {
    AppHeader,
    AppLoader
  },
  computed: {
    rows() {
      return this.totalRows;
    },
    createdAt(value) {
      return moment(value).format("LLL");
    },
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isGlobalLoader: "isLoading"
    })
  },
  mounted() {
    this.getClientsList();
  },
  methods: {
    ...mapMutations(["UPDATE_FORM"]),
    duplicateFormModal(title, description, id, clientId) {
      (this.duplicateForm.duplicateTitle = title),
        (this.duplicateForm.duplicateDescription = description),
        (this.duplicateForm.duplicateClientId = clientId);
      this.duplicateId = id;
      this.showDuplicateFormModal = true;
    },
    resetForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showNewCreateFormModal = false;
    },
    resetDuplicateForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showDuplicateFormModal = false;
    },
    async duplicateFormApiCall() {
      let formData = {
        createdById: localStorage.getItem("userId"),
        clientId: this.duplicateForm.duplicateClientId.value,
        form_id: this.duplicateId,
        formType: this.duplicateForm.duplicateselectFormType,
        formTitle: {
          english: this.duplicateForm.duplicateTitle
        },
        formDescription: {
          english: this.duplicateForm.duplicateDescription
        }
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP("post", "v1/form/duplicate", formData, {
          Authorization: token
        });
        if (result && result.data.httpStatus == 200) {
          this.submiting = false;
          this.isLoading = false;
          this.responseSuccess = true;
          this.$v.$reset();
          let form = JSON.parse(result.data.form.schema);
          this.newFormId = result.data.formId;
          this.updateFormToStore(form);
        }
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    },

    duplicateForms() {
      this.$v.duplicateForm.$touch();
      if (this.$v.duplicateForm.$anyError) {
        return;
      }
      this.duplicateFormApiCall().then(this.reloadTable);
    },
    async myProvider(ctx) {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        companyId: this.$route.params.id
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/getformslistclientid", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },

    async getClientsList() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("get", "v1/getclientslist", null, {
          Authorization: token
        });
        this.clients = result.data.clients;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    async getForm(formId, route) {
      localStorage.removeItem("activeFormId");
      this.updateFormToStore({});
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP("get", "v1/form/" + formId, null, {
        Authorization: token
      });
      this.isLoading = false;
      if (result.data.form && result.data.form.schema) {
        let form = JSON.parse(result.data.form.schema);
        localStorage.setItem("activeFormId", formId);
        this.updateFormToStore(form);
        window.location.href = route;
      }
    },

    async viewUserForm(formId, route) {
      localStorage.removeItem("activeFormId");
      this.updateFormToStore({});
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP("get", "v1/form/" + formId, null, {
        Authorization: token
      });
      this.isLoading = false;
      if (result.data.form && result.data.form.schema) {
        let form = result.data.form.schema;
        localStorage.setItem("activeFormId", formId);
        localStorage.setItem("activeFormSchema", form);

        this.$router.push({
          path: route,
          params: {
            from: "home"
          }
        });
      }
    },

    updateFormToStore(form) {
      // this.UPDATE_FORM(form);
      // this.reloadTable();
    },

    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },

    async createFormApiCall() {
      this.$v.newForm.$touch();
      if (this.$v.newForm.$anyError) {
        return;
      }
      let formData = {
        createdById: localStorage.getItem("userId"),
        copy_of_form_id: null,
        clientId: this.newForm.clientId.value,
        formId: null,
        formStyle: {
          backgroundColor: null,
          backgroundImage: null,
          backgroundSize: null,
          backgroundRepeat: null,
          backgroundPosition: null,
          height: null,
          width: null,
          opacity: 1,
          padding: {
            top: null,
            right: null,
            bottom: null,
            left: null
          },
          margin: {
            top: null,
            right: null,
            bottom: null,
            left: null
          },
          border: {
            top: null,
            right: null,
            bottom: null,
            left: null
          }
        },
        formTranslationType: "custom",
        formTitle: {
          english: this.newForm.formTitle
        },
        formDescription: {
          english: this.newForm.formDescription
        },
        formIntroText: {
          english: null
        },
        formType: this.newForm.selectFormType,
        formLayout: this.formLayout || "vertical",
        formSection: [
          {
            type: "section",
            id: uid(),
            index: 0,
            name: "",
            isRepeatable: false,
            advance: {
              hideSectionTitle: false
            },
            sectionTitle: {
              english: "Section 1 Title"
            },
            formElements: []
          }
        ],
        formStatus: 0,
        formDefaultLanguage: "english",
        formVersion: null,
        formTranslations: ["English"],
        formJSCode: null,
        formCSS: null,
        formRequirePassword: 0,
        formPassword: null
      };
      if (formData.formTitle.english || formData.formDescription.english)
        try {
          let token = "Bearer " + localStorage.getItem("accessToken");
          this.submiting = true;
          this.isLoading = true;
          this.newForm.formTitle = null;
          this.newForm.formDescription = null;
          this.newForm.clientId = null;
          let result = await HTTP("post", "v1/createform", formData, {
            Authorization: token
          });
          if (result && result.data.httpStatus == 200) {
            this.submiting = false;
            this.isLoading = false;
            this.responseSuccess = true;
            this.$v.$reset();
          }
        } catch (error) {
          this.submiting = false;
          this.isLoading = false;
        }
    },

    createForm() {
      this.createFormApiCall().then(this.reloadTable);
    }
  }
};
</script>

<style scoped>
.table-col {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}
</style>
